var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保险介绍")))])]), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.COLUMNSPLAN,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "rights",
      fn: function (text) {
        return _vm._l(text, function (item, index) {
          return _c("div", {
            key: item.name
          }, [_vm._v(" " + _vm._s(index + 1) + "、" + _vm._s(item.name || "-") + "  保障金额：" + _vm._s(item.value || "-") + "；权益说明：" + _vm._s(item.info || "-") + " ")]);
        });
      }
    }])
  }, _vm._l(_vm.COLUMNSPLAN, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.insuranceInfo.termsList && _vm.insuranceInfo.termsList.length ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("条款文件")))])]) : _vm._e(), _vm.insuranceInfo.termsList && _vm.insuranceInfo.termsList.length ? _c("div", [_c("a-checkbox", {
    on: {
      change: function ($event) {
        _vm.checked = !_vm.checked;
      }
    }
  }), _c("span", [_vm._v(" 我已阅读并同意 "), _c("span", {
    staticStyle: {
      color: "#1890ff"
    }
  }, _vm._l(_vm.insuranceInfo.termsList, function (item, index) {
    return _c("span", {
      key: index,
      staticStyle: {
        cursor: "pointer",
        color: "#1890ff"
      },
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.toRead(item);
        }
      }
    }, [_vm._v("《" + _vm._s(item.name) + "》")]);
  }), 0), _vm._v(" 以上内容 ")])], 1) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      disabled: !_vm.checked
    },
    on: {
      click: _vm.toInsurance
    }
  }, [_vm._v(_vm._s(_vm.$t("确认投保")))])], 1), _c("batch-insurance-modal", {
    attrs: {
      visible: _vm.batchVisible
    },
    on: {
      cancel: function ($event) {
        _vm.batchVisible = false;
      }
    }
  }), _c("read-clause-modal", {
    attrs: {
      visible: _vm.readVisible,
      clauseItem: _vm.clauseItem
    },
    on: {
      cancel: function ($event) {
        _vm.readVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };